import { DateString, fromDateString } from 'excellence-ui';
import { FORECAST_LIMIT } from '../../definitions';
import { SupplierContractData } from '../../stores/supplier-contracts.store';

export const getAvailableYears = (contract: SupplierContractData): string[] => {
  const currentYear = new Date().getFullYear();
  const contractStart = contract?.contractStartDate
    ? fromDateString(contract.contractStartDate as DateString)
    : undefined;
  const contractEnd = contract?.contractEndDate
    ? fromDateString(contract.contractEndDate as DateString)
    : undefined;
  const forecastLimit = currentYear + FORECAST_LIMIT;
  const priceComponents = contract?.priceComponents ?? [];

  // since we are handling forecast data, we can only show the current or following x years (based on the constant FORECAST_LIMIT)
  const firstYear = contractStart
    ? contractStart.getFullYear() <= currentYear
      ? currentYear
      : contractStart.getFullYear()
    : currentYear;
  const years: string[] = [];
  for (
    let year = firstYear;
    year <= forecastLimit && (!contractEnd || year <= contractEnd.getFullYear());
    year++
  ) {
    const yearPriceComponents = priceComponents.filter((priceComponent) => {
      const validFrom = priceComponent.validFrom
        ? fromDateString(priceComponent.validFrom as DateString).getFullYear()
        : null;
      const validTo = priceComponent.validTo
        ? fromDateString(priceComponent.validTo as DateString).getFullYear()
        : null;
      return (validFrom === null || year >= validFrom) && (validTo === null || year <= validTo);
    });
    if (yearPriceComponents.length) {
      years.push(year.toString());
    }
  }
  return years;
};
